import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Stack, Typography } from "@mui/material";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";
import { CreateUserDialog } from "Users/Components/CreateUserDialog";
import { UsersTable } from "Users/Components/UsersTable";
import { type FC, useState } from "react";

export const UsersPage: FC = () => {
	const [isDialogOpen, setIsDialogOpen] = useState(false);

	const handleCreateClick = () => {
		setIsDialogOpen(true);
	};

	const handleCloseDialog = () => {
		setIsDialogOpen(false);
	};

	return (
		<AuthenticatedLayout title="Users">
			<Box>
				<Stack
					direction="row"
					justifyContent="space-between"
					alignItems="center"
					mb={2}
				>
					<Typography variant="h4">Users</Typography>
					<Button
						variant="contained"
						color="primary"
						startIcon={<AddIcon />}
						onClick={handleCreateClick}
					>
						Create User
					</Button>
				</Stack>
				<UsersTable />
				<CreateUserDialog open={isDialogOpen} onClose={handleCloseDialog} />
			</Box>
		</AuthenticatedLayout>
	);
};
